/*
 * XOVIST Priority handling add-on: cart toggle (v2 2026-10-09; v7 2026-10-10: pre-ticked by country)
 * ------------------------------------------------------------------
 * Box:     snippets/xv-cart-summary.liquid (.xv-protect, cart drawer + /cart)
 * Styles:  assets/xv-protect.css (box + hides the add-on's own cart line)
 * Counts:  snippets/xv-protect-qty.liquid keeps the add-on out of the item counts
 * Loaded:  once, deferred, from snippets/global-typography-fix.liquid (<head>)
 * Product: "Priority Handling", handle 'priority-handling', variant 46193173561523.
 *          Cart lines are matched by VARIANT ID only (the box's data-variant-id,
 *          else VARIANT_ID below).
 *
 *  The box always shows what the cart holds. Since v7 (DEFAULT_TICKED = true, below) the
 *  add-on is added ONCE per cart, automatically, ONLY in PRETICK_COUNTRIES and never after the
 *  shopper switched it off; everywhere else (and when the country is unknown) it stays
 *  opt-in exactly as in v2. The rules are in the notes on DEFAULT_TICKED.
 *  - Tick -> cart/add.js {id, quantity 1}; untick -> cart/change.js {line key, 0}.
 *    Then an open drawer re-renders in place, a closed one quietly, /cart reloads once.
 *  - Tidy-up: quantity back to 1, extra lines removed, and the add-on removed when it is
 *    the only thing left in the cart.
 *  - While a cart write is in flight the cart forms' updates[] inputs are unnamed,
 *    so a Checkout click posts no stale positional quantities. Checkout is held only
 *    while the automatic add is in flight (v7, see the submit listeners).
 *  - Loop guards: a cap on automatic writes and re-renders per page view, and no
 *    automatic write on a /cart load that follows our own automatic reload.
 *  - The box never shows a stale state: on load it is set from its own data-qty (undoes
 *    a browser form-state restore), every tidy-up check sets it from /cart.js, and a
 *    page restored from the back/forward cache re-checks the cart. Display only, never a write.
 *
 * v6 (2026-10-10): the box is one compact row (snippets/xv-cart-summary.liquid). The "?" next to
 *  the name opens a short note under the row (no navigation); with modifier keys, or without this
 *  file, it is a plain link to /products/priority-handling.
 *  DEFAULT_TICKED below is the ONE switch for a ticked default.
 * v7 (2026-10-10, owner decision "Pre-ticked, except UK & EU", applied as "pre-tick except where
 *  banned"): DEFAULT_TICKED = true, pre-ticked ONLY in PRETICK_COUNTRIES (US CA JP HK MY PK AE BH TW);
 *  never in DEFAULT_OFF_COUNTRIES (GB, EU-27, IS LI NO, CH KR SG AU NZ), in any other country, or
 *  when the country is unknown. Setting DEFAULT_TICKED = false behaves exactly as v6 (opt-in only).
 */
(function () {
  'use strict';
  if (window.xvProtect) return;

  var VARIANT_ID = '46193173561523';     /* fallback only: the box's data-variant-id wins */
  var RELOAD_KEY = 'xv_protect_reload';  /* sessionStorage: time of our last AUTOMATIC /cart reload */
  /* keys written by the v1 build (remembered choice, auto-add mark, country cache,
     failure flag); they have no purpose any more and are cleared on load */
  var OLD_KEYS = [
    ['localStorage', 'xv_protect'], ['localStorage', 'xv_protect_auto'],
    ['sessionStorage', 'xv_protect_geo'], ['sessionStorage', 'xv_protect_fail']
  ];
  var BOX = '[data-xv-protect]';
  var INPUT = '[data-xv-protect] input[type=checkbox]';
  var QTY = 'input[name="updates[]"]';
  var DEBOUNCE_MS = 150;
  var MAX_AUTO_WRITES = 6;  /* automatic tidy-up writes per page view (reset by a tick/untick) */
  var MAX_HEALS = 2;        /* re-renders of a drawer that shows a stale cart, per page view */

  /* ---------- default state: the ONE switch ----------
   * DEFAULT_TICKED = true (v7, owner decision 2026-10-10 "Pre-ticked, except UK & EU", applied
   *   as "pre-tick except where banned"): a cart with products and no add-on line gets it added
   *   ONCE per cart, so the box shows ticked (price "+$4.99" beside the switch, and the summary
   *   row "Priority handling (optional) $4.99") and the shopper can switch it off. Added ONLY when
   *   ALL of these hold:
   *   - the detected IP country (assets/xv-card-gate.js xvCardGate.country(); this file makes no
   *     geo request of its own) is KNOWN and is in PRETICK_COUNTRIES and not in DEFAULT_OFF_COUNTRIES,
   *   - the picked country (localization, the box's data-country), when present, passes the same test,
   *   - the shopper never switched it off on this browser (localStorage DECLINED_KEY),
   *   - this cart (cart token) has not had its automatic add yet (localStorage AUTO_KEY),
   *   - browser storage works (an untick must be remembered),
   *   - a box is on the page, no checkout submit is under way, the automatic-write cap is not
   *     reached, and it is not a /cart load right after our own automatic reload.
   *   An automatically added line the shopper has not touched since (localStorage AUTO_LINE_KEY)
   *   is taken out again when the detected or picked country turns out NOT to pass (e.g. the
   *   shopper picks AU after it was added for the US). A line the shopper ticked is never removed.
   *   A Checkout click while the automatic add is in flight (switch not yet shown on) is held;
   *   the shopper sees the switch on and the new total, and clicks Checkout again.
   * DEFAULT_TICKED = false: behaves exactly as v6 (opt-in everywhere; no xv_ph_* key is written).
   * Risks: research/uk-eu-2026-10-09/lane-addon-verified.md 2.1 and 2.3 (that review advised
   *   unticked everywhere: US "high risk" under ROSCA / 16 CFR 310.2, an IP country is not the
   *   ship-to country, Shopify App Requirements 1.19). PRETICK_COUNTRIES is the review's (c)
   *   markets (no ban found) + TW (not covered by the review); DEFAULT_OFF_COUNTRIES is every
   *   market it marks (b) "must be unticked": GB, EU-27, EEA (IS LI NO), CH, KR, SG, AU, NZ.
   *   The never-list wins over the allow-list, so adding one of those codes above changes nothing. */
  var DEFAULT_TICKED = false;
  var PRETICK_COUNTRIES = ['US', 'CA', 'JP', 'HK', 'MY', 'PK', 'AE', 'BH', 'TW'];
  var DEFAULT_OFF_COUNTRIES = [
    'GB',
    'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE',
    'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE',
    'IS', 'LI', 'NO',
    'CH', 'KR', 'SG', 'AU', 'NZ'
  ];
  var DECLINED_KEY = 'xv_ph_declined';  /* localStorage: the shopper switched it off (only with DEFAULT_TICKED) */
  var AUTO_KEY = 'xv_ph_auto';          /* localStorage: cart token that already got the automatic add */
  var AUTO_LINE_KEY = 'xv_ph_auto_line'; /* localStorage: cart token whose add-on line came from the automatic
                                            add and was not touched by the shopper since */
  var HOLD_MS = 5000;                   /* longest a Checkout click is held for an in-flight automatic add */

  var vid = VARIANT_ID;
  var busy = false;
  var reloading = false;
  var leaving = false;     /* a cart form (Checkout) was submitted */
  var autoWrites = 0;
  var heals = 0;
  var okWrites = 0;        /* cart writes that succeeded in the current job */
  var fresh = false;       /* ...and the cart markup was re-rendered after them */
  var leaveTimer = 0;
  var autoSince = 0;       /* time the automatic add started; 0 once its job is done */
  var queued = null;
  var timer = 0;
  var ready = false;

  /* ---------- storage (may throw or be empty) ---------- */
  function store(kind) { try { return window[kind]; } catch (e) { return null; } }
  function sget(kind, k) { try { var s = store(kind); return s ? s.getItem(k) : null; } catch (e) { return null; } }
  function sset(kind, k, v) { try { var s = store(kind); if (s) s.setItem(k, v); } catch (e) { /* ignore */ } }
  function sdel(kind, k) { try { var s = store(kind); if (s) s.removeItem(k); } catch (e) { /* ignore */ } }
  function recentReload(ms) {
    var t = Number(sget('sessionStorage', RELOAD_KEY)) || 0;
    return !!t && Date.now() - t < ms;
  }

  /* ---------- Shopify AJAX cart ---------- */
  function route(name, fallback) { var r = window.routes || {}; return r[name] || fallback; }
  function request(url, body) {
    var opts = { credentials: 'same-origin', headers: { Accept: 'application/json' } };
    if (body) {
      opts.method = 'POST';
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    } else {
      opts.cache = 'no-store';
    }
    return fetch(url, opts).then(function (r) {
      if (!r.ok) throw new Error('xv-protect: HTTP ' + r.status);
      return r.json();
    });
  }
  function post(url, body) {
    return request(url, body).then(function (j) { okWrites++; return j; });
  }
  function getCart() { return request(route('cart_url', '/cart') + '.js'); }
  function addOne() { return post(route('cart_add_url', '/cart/add') + '.js', { id: Number(vid), quantity: 1 }); }
  function setLine(key, qty) { return post(route('cart_change_url', '/cart/change') + '.js', { id: key, quantity: qty }); }
  function isAddon(item) { return !!item && String(item.variant_id) === vid; }
  /* DEFAULT_TICKED only (see above): may this cart get the add-on added once, automatically? */
  function cc(s) { var c = String(s || '').toUpperCase(); return /^[A-Z]{2}$/.test(c) ? c : ''; }
  function storageWorks() {
    try {
      var s = window.localStorage;
      if (!s) return false;
      s.setItem('xv_ph_t', '1');
      s.removeItem('xv_ph_t');
      return true;
    } catch (e) { return false; }
  }
  function pretick(c) { return PRETICK_COUNTRIES.indexOf(c) > -1 && DEFAULT_OFF_COUNTRIES.indexOf(c) < 0; }
  /* 'yes': pre-tick here; 'no': a KNOWN country (detected or picked) says never; 'unknown': no detected country yet */
  function verdict() {
    var b = box();
    var g = window.xvCardGate, seen = '';
    try { seen = cc(g && typeof g.country === 'function' ? g.country() : ''); } catch (e) { seen = ''; }
    var picked = b ? cc(b.getAttribute('data-country')) : '';
    if ((seen && !pretick(seen)) || (picked && !pretick(picked))) return 'no';
    return seen ? 'yes' : 'unknown';
  }
  function cartToken(cart) { return cart && cart.token ? String(cart.token) : ''; }
  function autoAllowed(cart, a) {
    if (!DEFAULT_TICKED) return false;
    if (a.lines.length || a.others < 1) return false;
    if (!box() || verdict() !== 'yes') return false;
    if (!storageWorks() || sget('localStorage', DECLINED_KEY)) return false;
    var token = cartToken(cart);
    if (!token || sget('localStorage', AUTO_KEY) === token) return false;
    return true;
  }
  function autoAdd(cart) {
    var token = cartToken(cart);
    sset('localStorage', AUTO_KEY, token);
    sset('localStorage', AUTO_LINE_KEY, token);
    autoSince = Date.now(); /* Checkout is held until this job is done (the submit listeners) */
    return addOne().then(function () { return true; });
  }
  /* DEFAULT_TICKED only: an automatic line the shopper has not touched, in a cart whose known
     country does not get the pre-tick (picked or detected after the add), is taken out again */
  function autoLineOut(cart, a) {
    if (!DEFAULT_TICKED) return false;
    var token = cartToken(cart);
    var mark = sget('localStorage', AUTO_LINE_KEY);
    if (!mark) return false;
    if (mark !== token || !a.lines.length) { sdel('localStorage', AUTO_LINE_KEY); return false; } /* stale mark */
    return a.others > 0 && verdict() === 'no';
  }
  function autoRemove(a) {
    sdel('localStorage', AUTO_LINE_KEY);
    return removeAll(a);
  }
  function analyse(cart) {
    var a = { lines: [], qty: 0, others: 0, count: (cart && cart.item_count) || 0 };
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (isAddon(items[i])) { a.lines.push(items[i]); a.qty += items[i].quantity; }
      else a.others += items[i].quantity;
    }
    return a;
  }
  function removeAll(a) {
    return a.lines.reduce(function (p, l) {
      return p.then(function () { return setLine(l.key, 0); });
    }, Promise.resolve()).then(function () { return true; });
  }
  function normalise(a) {
    return a.lines.reduce(function (p, l, i) {
      var q = i === 0 ? 1 : 0;
      return p.then(function () { return l.quantity === q ? null : setLine(l.key, q); });
    }, Promise.resolve()).then(function () { return true; });
  }

  /* ---------- DOM ---------- */
  function box() { return document.querySelector(BOX); }
  function readVariant() {
    var b = box();
    var v = b && b.getAttribute('data-variant-id');
    if (v && /^[0-9]+$/.test(v)) vid = v;
    return vid;
  }
  function each(sel, fn) {
    var els = document.querySelectorAll(sel);
    for (var i = 0; i < els.length; i++) fn(els[i]);
  }
  /* The drawer and /cart forms post updates[] BY POSITION on Checkout; while a write
     is in flight their line list is stale, so unname those inputs until fresh markup
     arrives (quantity changes themselves go through cart.js by line index). */
  function lockQty() {
    each(QTY, function (el) { el.setAttribute('data-xv-name', 'updates[]'); el.removeAttribute('name'); });
  }
  function unlockQty() {
    each('input[data-xv-name]', function (el) {
      el.setAttribute('name', el.getAttribute('data-xv-name'));
      el.removeAttribute('data-xv-name');
    });
  }
  function setBusy(on) {
    busy = on;
    each(BOX, function (b) {
      b.classList.toggle('is-busy', on);
      b.setAttribute('aria-busy', on ? 'true' : 'false');
    });
    each(INPUT, function (inp) { inp.disabled = on; });
    if (on) lockQty();
  }
  function setChecked(on) { each(INPUT, function (inp) { inp.checked = on; }); }
  function isCartPage() { return !!document.getElementById('main-cart-items'); }
  function num(el, attr) { return parseInt(el.getAttribute(attr), 10) || 0; }

  /* Header bubble without the add-on. AJAX re-renders already leave it out in Liquid;
     sections/header.liquid (not edited) prints the raw count on page load. */
  function fixBubble(a) {
    var b = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    if (!b) return;
    var n = Math.max(0, a.count - a.qty);
    if (n === 0) { b.parentNode.removeChild(b); return; }
    var s = b.querySelector('span[aria-hidden=true]');
    var h = b.querySelector('.visually-hidden');
    if (s && s.textContent.trim() !== String(n)) s.textContent = String(n);
    if (h) { var t = h.textContent, nt = t.replace(/[0-9]+/, String(n)); if (nt !== t) h.textContent = nt; }
    if (!s && !h && b.textContent.trim() !== String(n)) b.textContent = String(n);
  }

  /* A theme re-render can land after ours with an older cart (cart.js refetches the
     drawer on cartUpdate in parallel). True when a box or the drawer count disagrees. */
  function staleView(a) {
    if (isCartPage()) return false;
    var bad = false;
    each('#CartDrawer ' + BOX, function (b) {
      if (num(b, 'data-qty') !== a.qty || num(b, 'data-others') !== a.others) bad = true;
    });
    var c = document.querySelector('#CartDrawer .gb-cart-total-item');
    if (c && (parseInt(c.textContent, 10) || 0) !== a.others) bad = true;
    return bad;
  }

  /* ---------- re-render after a change ---------- */
  function refresh(auto) {
    if (isCartPage()) {
      reloading = true;
      if (auto) sset('sessionStorage', RELOAD_KEY, String(Date.now()));
      window.location.reload();
      return Promise.resolve();
    }
    var d = document.querySelector('cart-drawer');
    if (!d) { fresh = true; return Promise.resolve(); }
    var p;
    if (d.classList.contains('active') && typeof window.refreshCartDrawer === 'function') {
      p = Promise.resolve(window.refreshCartDrawer()); /* drawer's own refresh: stays open */
    } else if (d.classList.contains('active') && typeof d.refreshCartDrawer === 'function') {
      p = Promise.resolve(d.refreshCartDrawer());
    } else {
      p = quietRefresh(d);
    }
    return p.then(function (ok) { if (ok !== false) fresh = true; });
  }
  /* drawer closed: update it without opening it */
  function quietRefresh(d) {
    var fns = window.cartFunctions;
    if (!fns || typeof fns.updateCartDrawer !== 'function') return Promise.resolve(false);
    return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('xv-protect: HTTP ' + r.status);
        return r.json();
      })
      .then(function (s) {
        var p = new DOMParser();
        var nd = s && s['cart-drawer'] && p.parseFromString(s['cart-drawer'], 'text/html').querySelector('#CartDrawer');
        if (!nd) return false;
        fns.updateCartDrawer(d, nd, false);
        var bubble = document.getElementById('cart-icon-bubble');
        var sec = s['cart-icon-bubble'] && p.parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (bubble && sec) {
          var type = bubble.getAttribute('data-cart-icon-type');
          bubble.innerHTML = sec.innerHTML;
          var w = bubble.querySelector('.svg-wrapper');
          if (w && type) {
            var icon = type === 'bag'
              ? w.querySelector('.cart-icon-bag')
              : w.querySelector(bubble.querySelector('.cart-count-bubble') ? '.cart-icon-cart' : '.cart-icon-cart-empty');
            if (icon) icon.style.display = 'flex';
          }
        }
        return true;
      });
  }

  /* ---------- the automatic job: tidy-up, and (DEFAULT_TICKED only) the one automatic add or its removal ---------- */
  function schedule(load) {
    queued = { load: !!load && (!queued || queued.load) };
    clearTimeout(timer);
    timer = setTimeout(flush, DEBOUNCE_MS);
  }
  function flush() {
    if (reloading || busy || !queued) return; /* done() flushes again when busy ends */
    var job = queued;
    queued = null;
    run(job);
  }
  function startJob() { okWrites = 0; fresh = false; setBusy(true); }
  function done() {
    if (reloading) return; /* /cart is reloading to show it: Checkout stays held (HOLD_MS at most) */
    autoSince = 0;         /* the automatic add (if any) is on screen now, or it failed: Checkout is free */
    if (!okWrites || fresh) unlockQty(); /* else the markup may be stale: keep updates[] unnamed */
    setBusy(false);
    if (queued) { clearTimeout(timer); timer = setTimeout(flush, DEBOUNCE_MS); }
  }
  function write(p) { autoWrites++; return p; }
  function heal(a) {
    if (heals >= MAX_HEALS || !staleView(a)) return false;
    heals++;
    return true;
  }
  function run(job) {
    readVariant();
    startJob();
    getCart() /* always re-read the cart before acting */
      .then(function (cart) {
        var a = analyse(cart);
        fixBubble(a);
        setChecked(a.lines.length > 0); /* the box shows what the cart holds (display only) */
        if (leaving || autoWrites >= MAX_AUTO_WRITES) return false;
        /* a /cart load right after our own automatic reload writes nothing (no reload loops) */
        if (job.load && isCartPage() && recentReload(10000)) return false;
        if (a.lines.length && a.others === 0) return write(removeAll(a));                       /* alone */
        if (a.lines.length > 1 || (a.lines.length && a.qty !== 1)) return write(normalise(a));   /* qty 1 */
        if (autoLineOut(cart, a)) return write(autoRemove(a));    /* DEFAULT_TICKED only: country now says never */
        if (autoAllowed(cart, a)) return write(autoAdd(cart));    /* DEFAULT_TICKED only; false = never */
        return heal(a);
      })
      .then(function (changed) { if (changed) return refresh(true); })
      .catch(function () { /* leave the cart as it is */ })
      .then(done);
  }

  /* ---------- the shopper ticks / unticks (with DEFAULT_TICKED false, the only way the add-on is added) ---------- */
  function onToggle(e) {
    var t = e.target;
    if (!t || typeof t.matches !== 'function' || !t.matches(INPUT)) return;
    var on = t.checked;
    if (busy || reloading) { t.checked = !on; return; }
    autoWrites = 0;
    if (DEFAULT_TICKED) {
      if (!on) sset('localStorage', DECLINED_KEY, '1'); /* never re-added automatically */
      sdel('localStorage', AUTO_LINE_KEY);               /* the shopper's own choice from now on: never taken out */
    }
    var b = t.closest(BOX);
    var v = b && b.getAttribute('data-variant-id');
    if (v && /^[0-9]+$/.test(v)) vid = v;
    var focusId = document.activeElement === t ? t.id : '';
    setChecked(on); /* keep a second box (drawer + /cart) in step */
    startJob();
    getCart()
      .then(function (cart) {
        var a = analyse(cart);
        if (on) {
          if (a.others === 0) throw new Error('xv-protect: the cart has no products');
          if (!a.lines.length) return addOne().then(function () { return true; });
          if (a.lines.length > 1 || a.qty !== 1) return normalise(a);
          return false;
        }
        return a.lines.length ? removeAll(a) : false;
      })
      .then(function (changed) { if (changed) return refresh(false); })
      .catch(function () { if (!okWrites) setChecked(!on); /* nothing changed: show what the cart holds */ })
      .then(done)
      .then(function () {
        /* the re-render replaced the box: give keyboard users their focus back */
        var n = focusId && !reloading ? document.getElementById(focusId) : null;
        if (n && document.activeElement !== n) {
          try { n.focus({ preventScroll: true }); } catch (err) { n.focus(); }
        }
      });
  }
  document.addEventListener('change', onToggle);

  /* ---------- the "?" next to the name: opens / closes the short note under the row ----------
     A plain click only; a modifier click (new tab) or a link without its note opens the Details page. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var a = t && typeof t.closest === 'function' ? t.closest('[data-xv-protect-info]') : null;
    if (!a || e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var id = a.getAttribute('aria-controls');
    var n = id ? document.getElementById(id) : null;
    if (!n) return;
    e.preventDefault();
    var open = n.hasAttribute('hidden');
    if (open) n.removeAttribute('hidden'); else n.setAttribute('hidden', '');
    a.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---------- triggers: the automatic job (an add only with DEFAULT_TICKED, see autoAllowed) ---------- */
  document.addEventListener('cart-drawer:render', function () {  /* after add to cart (renderContents) */
    if (busy) lockQty();
    schedule(false);
  });
  document.addEventListener('cart-drawer:update', function () {  /* any cart.js drawer re-render */
    if (busy) lockQty();
    schedule(false);
  });
  document.addEventListener('cart-drawer:open', function () { schedule(false); });
  /* Checkout (or any cart form) submitted: start no more automatic writes while the
     page navigates; if it is still here after 8 s (submit cancelled), carry on.
     v7: while the automatic add is in flight the shopper has not seen the switch on or the new
     total yet, so that submit is held (cancelled before any other handler sees it); the
     re-render then shows both and the shopper clicks Checkout again. At most HOLD_MS. */
  function cartForm(f) { return !!f && (f.id === 'CartDrawer-Form' || f.id === 'cart'); }
  window.addEventListener('submit', function (e) {
    if (!cartForm(e.target) || !autoSince || Date.now() - autoSince >= HOLD_MS) return;
    e.preventDefault();
    e.stopImmediatePropagation();
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!cartForm(f)) return; /* (a held submit never gets here) */
    leaving = true;
    queued = null;
    clearTimeout(leaveTimer);
    leaveTimer = setTimeout(function () { leaving = false; }, 8000);
  });
  /* back/forward cache restore: the cart may have changed in another page, so re-check it */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    leaving = false;
    schedule(false);
  });

  function onReady() {
    if (ready) return;
    ready = true;
    for (var i = 0; i < OLD_KEYS.length; i++) sdel(OLD_KEYS[i][0], OLD_KEYS[i][1]);
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      /* quantity changes and removals (assets/cart.js) and product-form adds */
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { schedule(false); });
    }
    /* undo a browser form-state restore: each box starts as its Liquid cart state */
    each(BOX, function (el) {
      var i = el.querySelector('input[type=checkbox]');
      if (i) i.checked = num(el, 'data-qty') > 0;
    });
    readVariant();
    var b = box();
    var qty = b ? num(b, 'data-qty') : 0;
    var others = b ? num(b, 'data-others') : 0;
    if (qty > 0) fixBubble({ count: others + qty, qty: qty });
    /* page load: no request at all unless the Liquid data shows a tidy-up is needed */
    if (qty > 1 || (qty > 0 && others === 0)) schedule(true);
    /* DEFAULT_TICKED only: once the card gate knows the country (at once if it already does),
       check the cart when it may get the automatic add, or when an untouched automatic line sits
       in a cart whose country says never. Otherwise no request, as in v2. */
    else if (DEFAULT_TICKED && b && others > 0 && (qty === 0 || sget('localStorage', AUTO_LINE_KEY))) {
      var check = function () {
        var v = verdict();
        if (qty === 0 ? v === 'yes' && !sget('localStorage', DECLINED_KEY) : v === 'no') schedule(true);
      };
      var g = window.xvCardGate;
      if (g && typeof g.onSettle === 'function') g.onSettle(check);
      else if (qty > 0) check(); /* no card gate: only the picked country can say never */
    }
  }
  /* after every deferred script (cart.js, cart-drawer.js) has run */
  if (document.readyState === 'complete') onReady();
  else {
    document.addEventListener('DOMContentLoaded', onReady);
    window.addEventListener('load', onReady);
  }

  window.xvProtect = {
    version: '2026-10-10-v7-pretick',
    defaultTicked: DEFAULT_TICKED,
    pretickCountries: DEFAULT_TICKED ? PRETICK_COUNTRIES.filter(pretick) : [],
    sync: function () { schedule(false); }
  };
})();
